<template>
	<div class="container-fluid p-0">
		<div class="loader-skeleton" v-if="loading">
			<div class="d-flex">
				<div class=" flex-grow-1">
					<PuSkeleton width="100vw" height="70vh" />
				</div>
			</div>
		</div>

		<div class="slider">
			<VueSlickCarousel
				:arrows="false"
				:dots="false"
				:slidesToShow="1"
				:slidesToScroll="1"
				:autoplay="false"
				v-if="!loading && items.length > 0"
			>
				<div v-for="item in items" :key="item.id">
					<div class="block">
						<div class="slide">
							<div
								class="img"
								v-rellax="{ speed: -6 }"
								:style="'background-image:url(' + item.backgroundImage.url + ')'"
							></div>

							<div class="data only-mobile">
								<!-- <h1 class="title " v-html="item.formattedTitle"></h1>
								<p class="lead-text mt-2">
									{{ item.description }}
								</p> -->
							</div>
						</div>

						<div class="content ">
							<div class="container">
								<div class="row">
									<div class="col">
										<div v-if="item.mainImage">
											<img
												:src="item.mainImage.url"
												class="img-fluid"
												:style="`max-width: 320px;`"
											/>
										</div>

										<div class="content-block" v-if="!item.mainImage">
											<h1 class="title " v-html="item.formattedTitle"></h1>
											<p class="lead-text mt-2">
												{{ item.description }}
											</p>

											<div class="separator mt-3"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</VueSlickCarousel>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	data() {
		return {
			items: [],
			loading: true
		}
	},
	beforeMount() {
		this.load()
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query {
							mainSliders {
								data {
									id
									formattedTitle
									description
									mainImage {
										id
										type
										filename
										url
										urlThumb
									}
									secondaryImage {
										id
										type
										filename
										url
										urlThumb
									}
									backgroundImage {
										id
										type
										filename
										url
										urlThumb
									}
								}
							}
						}
					`,
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.items = data.mainSliders.data
					this.loading = false
				})
				.catch(() => {})
		}
	}
}
</script>

<style scoped lang="scss">
.slider {
	position: relative;

	.slide {
		width: 100vw;
		min-height: 600px;
		max-height: 60vw;
		position: relative;

		.img {
			position: absolute;
			height: 100%;
			width: 100%;
			background-size: cover;
			background-position: center center;
			/* animation: panning 20s infinite linear; */
		}
		.data {
			position: absolute;
			bottom: 26px;
			padding: 18px;
			color: #fff;
		}
		&:after {
			content: "";
			background-color: rgba(0, 0, 0, 0.4);
			display: block;
			height: 100%;
			left: 0;
			position: absolute;
			top: 0;
			width: 100%;
			z-index: 0;
		}
	}

	// &:after {
	// 	width: 100%;
	// 	content: "";
	// 	bottom: 0;
	// 	left: 0;
	// 	background-image: url("~@/assets/img/banner-shap.png");
	// 	position: absolute;
	// 	z-index: 1;
	// 	height: 134px;
	// 	background-repeat: no-repeat;
	// }
}

.block {
	/* display: flex; */
	position: relative;
	overflow: hidden;
}

.block .content {
	display: none;
	width: 100%;
	flex-basis: 0;
	padding: 18px;
	position: absolute;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
}
.block .content .content-block {
	max-width: 500px;
	height: fit-content;
}

.title {
	color: #fff;
	text-shadow: 1px 1px 1px #000;
	font-size: 24px;
	font-weight: 900;
}
.lead-text {
	color: #fff;
	font-size: 20px;
	text-shadow: 1px 1px 1px #000;
	font-weight: 600;
}

@media (min-width: 728px) {
	.slide {
		height: 75vh;
	}

	.block .content {
		display: flex;
	}
	/* .slide {
		float: left;
	} */
	.block .content {
		flex-grow: 1;
	}

	.title {
		font-size: 55px;
		line-height: 70px;
	}
	.lead-text {
		font-size: 20px;
	}
}

@keyframes panning {
	0% {
		background-position: 0% 0%;
	}
	100% {
		background-position: 75% 100%;
	}
}
</style>
